@let wizardHost = wizard();
<div class="flex flex-col gap-3">
  @if (wizardHost.fleetCatalogPanel() === "catalog") {
    <p class="text-sm leading-snug text-[#7a6b8a]">{{ "mobile.eachat.wizard.fleetVehicleCatalogHint" | translate }}</p>

    @if (wizardHost.equipmentLinesStepMissing()) {
      <p class="rounded-lg border border-destructive/25 bg-destructive/5 px-3 py-2 text-sm text-destructive">
        {{ "mobile.eachat.wizard.vehiclesValidation" | translate }}
      </p>
    }

    <div class="flex items-stretch gap-2 pr-3">
      <input
        type="search"
        name="fleetEquipmentCatalogSearch"
        class="min-h-[44px] min-w-0 max-w-[70%] flex-1 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm text-[#3d2652] placeholder:text-[#a49db0]"
        [placeholder]="'mobile.eachat.wizard.productSearchPlaceholder' | translate"
        [ngModel]="wizardHost.fleetCatalogSearchSig()"
        (ngModelChange)="wizardHost.onFleetEquipmentCatalogSearchChange($event)"
        [ngModelOptions]="{ standalone: true }"
        autocomplete="off"
      />
      <button
        type="button"
        class="relative inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-white text-[#5a2f6b] shadow-sm active:bg-[#faf7fc]"
        (click)="wizardHost.openFleetEquipmentSelectionPanel()"
        [attr.aria-label]="'mobile.eachat.wizard.openSelectionAria' | translate"
      >
        <span class="material-icons text-[24px]" aria-hidden="true">shopping_cart</span>
        @if (wizardHost.deliveryCartCount(); as cartCount) {
          @if (cartCount > 0) {
            <span
              class="absolute -right-1 -top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-[5px] text-[0.65rem] font-bold leading-none text-white"
              aria-hidden="true"
              >{{ cartCount }}</span
            >
          }
        }
      </button>
    </div>

    <p class="text-xs tabular-nums text-[#94a3b8]">
      {{ "mobile.eachat.wizard.productResultsCount" | translate }} : {{ wizardHost.fleetCatalogList().length }}
    </p>

    @if (wizardHost.fleetCatalogLoading()) {
      <div class="flex justify-center py-10">
        <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
      </div>
    } @else if (!wizardHost.fleetCatalogList().length) {
      <p class="rounded-xl border border-dashed border-[#ece4f3] bg-[#faf7fc] px-3 py-6 text-center text-sm text-[#7a6b8a]">
        {{ "mobile.eachat.wizard.fleetVehicleCatalogEmpty" | translate }}
      </p>
    } @else {
      <ul class="flex flex-col gap-2.5">
        @for (fleetEquipmentCatalogItem of wizardHost.fleetCatalogList(); track fleetCatalogTrack($index, fleetEquipmentCatalogItem)) {
          @let equipmentUid = wizardHost.fleetCatalogEquipmentUid(fleetEquipmentCatalogItem);
          <li class="rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm">
            <div class="flex items-start gap-2">
              <div class="min-w-0 flex-1 flex flex-col gap-0.5">
                <p class="text-sm font-semibold leading-snug text-[#1a1523]">
                  {{ wizardHost.fleetCatalogEquipmentPrimaryLabel(fleetEquipmentCatalogItem) }}
                </p>
                @if (wizardHost.fleetCatalogEquipmentSecondaryLabel(fleetEquipmentCatalogItem); as registrationLabel) {
                  @if (registrationLabel) {
                    <p class="font-mono text-[0.7rem] text-[#7a6b8a]">{{ registrationLabel }}</p>
                  }
                }
                <div class="mt-2 flex flex-col gap-1">
                  <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                    "mobile.eachat.wizard.vehicleTableColDesignation" | translate
                  }}</span>
                  <span class="text-sm leading-snug text-[#1a1523]">{{
                    fleetEquipmentCatalogItem.Designation?.trim() || ("app.shared.notprovided" | translate)
                  }}</span>
                </div>
              </div>
              <button
                type="button"
                class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-white shadow-sm active:opacity-90 disabled:opacity-35"
                [disabled]="!equipmentUid"
                (click)="wizardHost.addFleetCatalogEquipmentLine(fleetEquipmentCatalogItem)"
                [attr.title]="'mobile.eachat.wizard.addLineTitle' | translate"
                [attr.aria-label]="'mobile.eachat.wizard.addLineTitle' | translate"
              >
                <span class="material-icons text-[22px]" aria-hidden="true">add_shopping_cart</span>
              </button>
            </div>
          </li>
        }
      </ul>
    }
  } @else {
    <div class="flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-white text-[#5a2f6b]"
          (click)="wizardHost.closeFleetEquipmentSelectionPanel()"
          [attr.aria-label]="'mobile.eachat.wizard.backToCatalog' | translate"
        >
          <span class="material-icons" aria-hidden="true">arrow_back</span>
        </button>
        <div class="min-w-0 flex-1">
          <p class="text-base font-semibold text-[#3d2652]">{{ "mobile.eachat.wizard.selectionTitle" | translate }}</p>
        </div>
      </div>

      <p class="text-xs leading-snug text-[#7a6b8a]">{{ "mobile.eachat.wizard.vehicleSelectionHint" | translate }}</p>

      @if (wizardHost.selectionHydrating()) {
        <div class="flex items-center gap-2 rounded-lg border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-xs text-[#7a6b8a]">
          <span class="material-icons animate-spin text-[18px] text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
          {{ "mobile.eachat.wizard.selectionLoading" | translate }}
        </div>
      }

      @if (!wizardHost.deliveryProducts().length) {
        <p class="rounded-xl border border-dashed border-[#ece4f3] bg-[#faf7fc] px-3 py-6 text-center text-sm text-[#7a6b8a]">
          {{ "mobile.eachat.wizard.vehiclesEmpty" | translate }}
        </p>
      } @else {
        <ul class="flex flex-col gap-2.5">
          @for (deliveryLine of wizardHost.deliveryProducts(); track lineTrack($index, deliveryLine)) {
            <li class="rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm">
              <div class="flex gap-2">
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-semibold leading-snug text-[#1a1523]">
                    {{ deliveryLine.EquipmentVehicle?.IdentificationInfo?.trim() || ("app.shared.notprovided" | translate) }}
                  </p>
                  @if (deliveryLine.EquipmentVehicle?.RegistrationNumber?.trim(); as registrationNumber) {
                    <p class="mt-0.5 font-mono text-[0.7rem] text-[#7a6b8a]">{{ registrationNumber }}</p>
                  }
                  <div class="mt-2 flex flex-col gap-1">
                    <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                      "mobile.eachat.wizard.vehicleTableColDesignation" | translate
                    }}</span>
                    <span class="text-sm leading-snug text-[#1a1523]">{{
                      deliveryLine.EquipmentVehicle?.Designation?.trim() || ("app.shared.notprovided" | translate)
                    }}</span>
                  </div>
                </div>
                <button
                  type="button"
                  class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-white shadow-sm active:opacity-90"
                  (click)="wizardHost.removeDeliveryLine(deliveryLine)"
                  [attr.title]="'mobile.eachat.wizard.removeLineAria' | translate"
                  [attr.aria-label]="'mobile.eachat.wizard.removeLineAria' | translate"
                >
                  <span class="material-icons text-[22px]" aria-hidden="true">delete_outline</span>
                </button>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
